import { useState } from "react";
import { api, BACKEND_URL } from "@/lib/api";
import { toast } from "sonner";
import { Share2, Copy, Twitter, Download } from "lucide-react";

export default function ShareBar({ quote }) {
  const [open, setOpen] = useState(false);
  const shareUrl = `${window.location.origin}/quote/${quote.id}`;
  const ogUrl = `${BACKEND_URL}/api/og/${quote.id}.png`;
  const tweetText = `"${quote.text.slice(0, 140)}${quote.text.length > 140 ? "…" : ""}" — ${quote.speaker}\n\n${shareUrl}`;
  const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied.");
    } catch { toast.error("Could not copy."); }
  };

  return (
    <div className="border-ink bg-white p-5 shadow-brut-sm mt-6" data-testid="share-bar">
      <div className="flex items-center justify-between">
        <div>
          <div className="font-ui text-[10px] text-[#FF3333]">Spread it</div>
          <h3 className="font-display text-xl leading-tight">Share this record</h3>
        </div>
        <Share2 size={20} />
      </div>
      <div className="mt-4 grid grid-cols-3 gap-2">
        <a href={tweetUrl} target="_blank" rel="noreferrer" className="btn-outline text-xs flex items-center justify-center gap-2" data-testid="share-twitter">
          <Twitter size={12} /> Tweet
        </a>
        <button onClick={copyLink} className="btn-outline text-xs flex items-center justify-center gap-2" data-testid="share-copy">
          <Copy size={12} /> Link
        </button>
        <button onClick={() => setOpen((v) => !v)} className="btn-outline text-xs flex items-center justify-center gap-2" data-testid="share-toggle-card">
          <Download size={12} /> Card
        </button>
      </div>
      {open && (
        <div className="mt-4" data-testid="og-preview">
          <img src={ogUrl} alt="share card" className="w-full border-ink" />
          <a href={ogUrl} download={`tbvh-${quote.id}.png`} className="link-blue text-xs mt-2 inline-block" data-testid="og-download">
            Download PNG →
          </a>
        </div>
      )}
    </div>
  );
}
